<template>
	<c-tooltip position="top" align="end" color="white" width="300" style="width: 100%;">
		<div class="c-formula flex">
			<c-input v-model="valueData" :name="name" type="hidden"></c-input>
			<div class="flex-grow flex-start-center">
				<span>{{valueData}}</span>
			</div>
			<div class="c-formula-icon flex-center">
				<i class="tf">&#xe6a4;</i>
			</div>
		</div>

		<template v-if="formula" #tip>
			<div class="c-formula-content">
				<p>公式：</p>
				<p>{{formula}}</p>
			</div>
		</template>
	</c-tooltip>
</template>

<script>
	export default {
		name: 'cFormula',
		
		props: {
			value: [String, Number],
			name: String,
			formula: String
		},

		data() {
			return {
				valueData: ''
			}
		},

		watch: {
			value: {
				handler(val) {
					this.valueData = val;
				},
				immediate: true
			},

			valueData(val) {
				this.$emit('input', val);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-formula {
		box-sizing: border-box;
		border: 1px dashed var(--unit-border) !important;
		padding: 8px 0 8px 8px;
		line-height: 20px;
		white-space: pre-wrap;
		word-break: break-word;
		background: #f9f9f9;
		box-shadow: none !important;

		&-icon {
			min-width: 28px;
			font-size: 14px;
			text-align: center;
			color: #999;
		}

		&-content {
			padding: 5px 0;
			line-height: 20px;
			white-space: pre-wrap;
		}
	}
</style>
